import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ThietLapKhacCategoryService from "services/thietLapKhac/ThietLapKhacCategoryService";

export const GetAllDanhMucNganHang = createAsyncThunk(
  "ThietLapKhacCategory/getAllDanhMucNganHang",
  async (branchId, { rejectWithValue }) => {
    try {
      const response = await ThietLapKhacCategoryService.get(branchId);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const UpSertThietLapKhacCategoryApi = createAsyncThunk(
  "ThietLapKhacCategory/UpSertThietLapKhacCategoryApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await ThietLapKhacCategoryService.upSert(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  nganHangData: [],
};

const thietLapKhacCategorySlice = createSlice({
  name: "thietLapKhacCategory",
  initialState,
  reducers: {
    setDanhMucNganHang: (state, action) => {
      state.nganHangData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllDanhMucNganHang.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllDanhMucNganHang.fulfilled, (state, action) => {
        state.loading = false;
        state.nganHangData = action.payload;
      })
      .addCase(GetAllDanhMucNganHang.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertThietLapKhacCategoryApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpSertThietLapKhacCategoryApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(UpSertThietLapKhacCategoryApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { setDanhMucNganHang } = thietLapKhacCategorySlice.actions;

export default thietLapKhacCategorySlice.reducer;
